export const maskDate = value => {
	if ( value ) {
		// remove all non-digits and split string into an array
		const arr = value.toString()
			.replace( /[^0-9]/g, '' )
			.split( '' );

		// add "(" at index 0
		// add ")" at index 3
		// add "-" at index 6
		const maskedArr = arr.map( ( char, i ) => {
			switch ( i ) {
				case 2:
					return `/${ char }`;
				case 4:
					return `/${ char }`;
				default:
					return char;
			}
		} );

		// join array into a string
		return maskedArr.join( '' );
	}

	return '';
};

export const unmaskDate = value => {
	return new Date( value ).toLocaleDateString();
};
